export class EventBusEventTypeBase {
    public static readonly Login = 'LOGIN';
    public static readonly Logout = 'LOGOUT';
    public static readonly MenuTitle = 'MENUTITLE';
    public static readonly PageTitle = 'PAGETITLE';
    public static readonly CloseTab = 'CLOSETAB';
}
